export default __webpack_public_path__ + "static/media/destroy.0cee2f2b.svg";